export default ["$stateProvider", "$urlRouterProvider", function ($stateProvider, $urlRouterProvider) {
    // Now set up the states
    $stateProvider
        .state('messageOutbox', {
            parent : "app",
            url: "/messageoutbox?downloadError&title&createdAtFrom&createdAtUntil",
            feature: "menu.messages.outbox",
            views: {
                "main": {
                    template: require("./eaMessageOutboxPage/eaMessageOutboxPageModule.html"),
                    controller: "eaMessageOutboxPageModuleController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }]
            }
        })
        .state("messageNew",{
            parent : "app",
            url: "/messages/new",
            feature: "menu.messages.newMessage",
            views: {
                "main": {
                    template: require("./eaMessageCreatePage/eaMessageCreatePage.tpl.html"),
                    controller: "MessageCreatePageController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{
                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }],
                userHasDemoFeature: ["FeatureService", "$q", (FeatureService, $q) => {
                    return $q((resolve)=>{
                        FeatureService.hasDemoUserFeature().then(function(hasFeature) {
                            resolve(hasFeature);
                        });
                    });
                }]
            }
        })
        .state('messageComplain', {
            parent : "app",
            url: "/messages/complain/:trxid?trxids",
            feature: "menu.messages.newMessage",
            views: {
                "main": {
                    template: require("./eaMessageCreatePage/eaMessageCreatePage.tpl.html"),
                    controller: "MessageCreatePageController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }],
                userHasDemoFeature: ["FeatureService", "$q", (FeatureService, $q) => {
                    return $q((resolve)=>{
                        FeatureService.hasDemoUserFeature().then(function(hasFeature) {
                            resolve(hasFeature);
                        });
                    });
                }]
            }
        })
        .state('messageReply', {
            parent : "app",
            url: "/message/:id/reply",
            feature: "menu.messages.newMessage",
            views: {
                "main": {
                    template: require("./eaMessageCreatePage/eaMessageCreatePage.tpl.html"),
                    controller: "MessageCreatePageController as $ctrl"
                }
            },
            resolve : {
                ctrl : ["$q","$ocLazyLoad", ($q,$ocLazyLoad)=> {
                    return $q((resolve)=>{
                        require.ensure([],()=>{

                            let module = require("./index.js");
                            $ocLazyLoad.load({name : module.default});
                            resolve();
                        });
                    });
                }],
                userHasDemoFeature: ["FeatureService", "$q", (FeatureService, $q) => {
                    return $q((resolve)=>{
                        FeatureService.hasDemoUserFeature().then(function(hasFeature) {
                            resolve(hasFeature);
                        });
                    });
                }]
            }
        });
}];


// WEBPACK FOOTER //
// ./src/ui/modules/eaMessage/eaMessageOutbox/routes.js